export default __webpack_public_path__ + "static/media/Aura-Egg__44.15552f0f.png";